import React from "react";
import cx from "classnames";
import Tooltip from "../Tooltips/Tooltip";

interface IQuoteBreakdownSummaryRowProps {
    title: string;
    subtext?: string;
    tip?: string;
    className?: string;
    weight?: "regular" | "bold";
}

const QuoteBreakdownSummaryRow: React.FC<IQuoteBreakdownSummaryRowProps> = (props) => {
    const { title, subtext, tip, className, children } = props;
    const weight = props.weight || "regular";

    return (
        <div
            className={cx("layout-flex-row--justify-spaced", {
                [className]: !!className
            })}>
            <div className={"layout-flex-column"}>
                {/* Title Section */}
                <span
                    className={cx("layout-flex-row", "text-font-size-s", "text-primary", {
                        ["text-no-bold"]: weight === "regular",
                        ["text-bold"]: weight === "bold"
                    })}>
                    {title}
                    {tip && <Tooltip tooltipContent={tip} className={"space-pre-s"} />}
                </span>
                {subtext && (
                    <span className={cx("gap-m", "text-disclaimer", "text-font-size-xs")}>
                        {subtext}
                    </span>
                )}
            </div>
            {/* Child Component */}
            {children && <div>{children}</div>}
        </div>
    );
};

export default QuoteBreakdownSummaryRow;
